import React from 'react';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
} from '@material-ui/core';

export interface CheckboxGroupOption {
  id: string;
  name: string;
}

export interface CheckboxGroupProps {
  label: string;
  options: CheckboxGroupOption[];
  value: string[];
  onChange: (newValue: string[]) => void;
  error?: string;
  disabled?: boolean;
  row?: boolean;
  className?: string;
  'data-cy'?: string;
}

export const CheckboxGroup: React.FC<CheckboxGroupProps> = ({
  label,
  options,
  value,
  onChange,
  error,
  disabled = false,
  row = false,
  className,
  'data-cy': dataCy,
}) => {
  const handleToggle = (optionId: string) => (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    if (event.target.checked) {
      if (value.includes(optionId)) return;
      onChange([...value, optionId]);
    } else {
      onChange(value.filter(id => id !== optionId));
    }
  };

  return (
    <FormControl
      className={className}
      error={!!error}
      disabled={disabled}
      component="fieldset"
    >
      <FormLabel component="legend">{label}</FormLabel>
      <FormGroup row={row} data-cy={dataCy}>
        {options.map(option => (
          <FormControlLabel
            key={option.id}
            control={
              <Checkbox
                color="primary"
                value={option.id}
                checked={value.includes(option.id)}
                onChange={handleToggle(option.id)}
                disabled={disabled}
              />
            }
            label={option.name}
          />
        ))}
      </FormGroup>
      {error && <FormHelperText error>{error}</FormHelperText>}
    </FormControl>
  );
};

export default CheckboxGroup;
